import styled from "styled-components";

const StyledPreviewButton = styled.a`
  position: absolute;
  right: 0.5rem;
  font-size: 1rem;
`;

export default StyledPreviewButton;



// WEBPACK FOOTER //
// ./src/modules/common/components/form/ui/StyledPreviewButton.js